module.exports = __webpack_public_path__ + "files/953447cc225b1411d64d4b6a51e4bf0f.png";